import CtaGetList from './CtaGetList'

export default CtaGetList
